import { ComponentProps } from "react";
import cn from "classnames";
import calendarImg from "./img/calendar.svg";
import tariffImg from "./img/tariff.svg";
import transcodeImg from "./img/transcode.svg";
import desctopImg from "./img/desktop.svg";
import s from "./Actions.module.css";
import { ButtonWithImage } from "../ButtonWithImage";
import { ButtonGroup } from "../ButtonGroup";
import { useNavigate } from "react-router-dom";
import { User } from "../../features/api/apiSlice";

type Props = ComponentProps<'div'> & {
  onCreateBroadcast: () => void;
  onOpenTranscodePresetPopup: () => void;
  onOpenStudio: () => void;
  user?: User;
};

export function Actions({ className, onCreateBroadcast, onOpenTranscodePresetPopup, onOpenStudio }: Props) {
  const navigate = useNavigate();
  return (
    <div className={cn(s['actions'], className)}>
      <div className={s['actions__title']}>Действия</div>
      <div className={s.actions__buttons}>
        <ButtonGroup className={s['actions__button']}>
          <ButtonWithImage
            imgSrc={calendarImg}
            alt="Calendar"
            text="Запланировать эфир"
            className={s['button-with-image']}
            onClick={onCreateBroadcast}
          />
          <ButtonWithImage
            imgSrc={tariffImg}
            alt="Tariff"
            text="Мой тариф"
            className={s['button-with-image']}
            onClick={() => navigate('/tariffs')}
          />

          <ButtonWithImage
            imgSrc={desctopImg}
            alt="Studio"
            text="Студия Restream"
            className={s['button-with-image']}
            onClick={onOpenStudio}
          />

          <ButtonWithImage
            imgSrc={transcodeImg}
            alt="Transcoding"
            text="Транскодинг"
            className={s['button-with-image']}
            onClick={onOpenTranscodePresetPopup}
          />
        </ButtonGroup>
      </div>
    </div>
  );
}